import {Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormBuilder, FormControl} from '@angular/forms';
import {InvoiceService} from "../../services/invoice.service";
import {Invoice} from "../../interface/invoice";
import {COMPANY_ASF, COMPANY_ASF_PREMIUM, INVOICE_STATUS_TO_BE_CORRECTED, INVOICE_STATUS_TO_BE_REALIZED} from "../../services/dict.service";
import {HttpErrorResponse} from "@angular/common/http";
import {CountedAndPaginated} from "../../interface/response/counted-and-paginated";
import {Observable, ReplaySubject} from "rxjs";
import {take, takeUntil} from "rxjs/operators";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {KrkAddDialogData} from "../../../modules/krk/krk-add-dialog/krk-add-dialog.component";

export interface FileResult {
  file?: File;
  result?: boolean;
  uuid?: string;
  errorType?: string;
  errorText?: string;
}
export interface FileBase64 {
  filename: string;
  base64: string;
}
@Component({
  selector: 'app-bills-file-drag-and-drop',
  templateUrl: './bills-file-drag-and-drop.component.html',
  styleUrls: ['./bills-file-drag-and-drop.component.scss']
})
export class BillsFileDragAndDropComponent implements OnInit, OnDestroy {

  @Input() maxSize = 7340032;
  @Input() multiple = false;
  @Input() fileControl?: FormControl;
  @Input() fileResults?: FileResult[];
  @Input() acceptMime = '*/*';
  @Input() generateOutput = false;
  @Input() required = false;
  @Input() label = null;
  @Input() deleteInvoiceObject: Observable<any>;
  @Input() invoiceFileResult: Observable<Invoice>;
  @Input() invoiceObjectReturn: Observable<any>;

  // @Input() invoiceControl?: Invoice;
  @Output() fileSelected: EventEmitter<FileBase64> = new EventEmitter<FileBase64>();
  @Output() filesSelected: EventEmitter<FileBase64[]> = new EventEmitter<FileBase64[]>();
  @Output() invoiceControl = new EventEmitter<any>();
  @ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef;
  number: any;
  invoices?: Invoice[] = [];
  items?: Invoice[] = [];
  selectedFiles?: File[] = [];
  hidden: string;
  hiddenIndex: number;
  disabledInvoice = false;
  itemsSubject: ReplaySubject<CountedAndPaginated<Invoice>> = new ReplaySubject<CountedAndPaginated<Invoice>>(1);
  readonly COMPANY_ASF_PREMIUM = COMPANY_ASF_PREMIUM;
  readonly COMPANY_ASF = COMPANY_ASF;
  readonly INVOICE_STATUS_TO_BE_REALIZED = INVOICE_STATUS_TO_BE_REALIZED;
  readonly INVOICE_STATUS_TO_BE_CORRECTED = INVOICE_STATUS_TO_BE_CORRECTED;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private snack: MatSnackBar,
    private fb: FormBuilder,
    private invoiceService: InvoiceService,
  ) {
  }

  ngOnInit(): void {
    if (!this.fileControl) {
      this.fileControl = this.fb.control('');
    }
    this.fileControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        if (!val) {
          this.selectedFiles = [];
        }
      });

    this.deleteInvoiceObject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response) => {
        this.deleteInvoice(null, response.index);
      });

    this.invoiceObjectReturn
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response) => {
        this.updateInvoice(response.invoice.uuid, response.index);
      });

    this.loadInvoiceFileResult();


  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  loadInvoiceFileResult(): void {
    this.invoiceFileResult
      .pipe(takeUntil(this.destroyed$))
      .subscribe((invoice) => {
        // setTimeout(() => {
        //   this.invoiceService.get(invoice.id)
        //     .subscribe((respone) => {
        //       this.invoices.push(respone);
        //     });
        // }, 100);
        this.invoiceService.get(invoice.id)
          .subscribe((respone) => {
            this.invoices.push(respone);

          });
      });

  }

  onFilesSelect(fileList: FileList): void {
    this.invoices = [];
    let matchSizeLimit = true;
    Array.from(fileList).forEach((file: File) => {
      if (file.size > this.maxSize) {
        matchSizeLimit = false;
      }
    });

    if (!matchSizeLimit) {
      this.snack.open('Wybrany plik jest za duży!', '', {duration: 2000});
      return;
    }

    this.selectedFiles = [];
    if (this.multiple) {
      Array.from(fileList).forEach((file: File) => {
        this.selectedFiles.push(file);
      });
    } else {
      this.selectedFiles.push(Array.from(fileList)[0]);
    }
    this.fileControl.setValue(this.selectedFiles);
    this.fileDropEl.nativeElement.value = '';

    if (this.generateOutput) {
      this.dispatchEvents();
    }

  }

  dispatchEvents(): void {
    const filesBase64: FileBase64[] = [];
    let processedFiles = 0;

    this.selectedFiles.forEach((file: File) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileBase64 = /base64,(.+)/.exec(reader.result.toString());
        filesBase64.push({
          filename: file.name,
          base64: fileBase64 && fileBase64.length > 1 ? fileBase64[1] : ''
        });

        processedFiles++;

        if (processedFiles === this.selectedFiles.length) {
          if (this.multiple) {
            this.filesSelected.emit(filesBase64);
          } else {
            this.fileSelected.emit(filesBase64[0]);
          }
        }
      };
    });

    if (this.selectedFiles.length === 0) {
      if (this.multiple) {
        this.filesSelected.emit([]);
      } else {
        this.fileSelected.emit(null);
      }
    }
  }

  openFileSelect(): void {
    this.fileDropEl.nativeElement.click();
  }

  unselectFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.dispatchEvents();
  }

  deleteInvoice(uuid, index): void
  {
    this.invoices.splice(index, 1);
    if (uuid) {
      this.invoiceService.delete(uuid)
        .subscribe({
          next: () => {
            this.invoiceControl.emit({invoice: uuid, index, delete: true});
            this.snack.open('Pomyślnie usunięto rachunek', '', {duration: 2000});
          }, error: (error: HttpErrorResponse) => {
            // this.snack.open('Nie można usunąć rachunek', error.status.toString(), {duration: 2000});
          }
        });

    }
  }
  getInvoice(uuid, index): void {
    if (uuid) {
      this.invoiceService.get(uuid)
        .pipe()
        .subscribe((response) => {
          if (response !== null) {
            this.invoiceControl.emit({invoice: response, index});
          }
        }, (error: HttpErrorResponse) => {
          this.snack.open('Rachunek został usunięty', error.status.toString(), {duration: 2000});
        });
    }
  }
  updateInvoice(uuid, index): void {
    if (uuid) {
      this.invoiceService.get(uuid)
        .pipe()
        .subscribe((response) => {
          if (response !== null) {
            this.invoiceControl.emit({invoice: response, index});
            this.invoices.splice(index, 1, response );
          }
        }, (error: HttpErrorResponse) => {
          this.snack.open('Rachunek został usunięty', error.status.toString(), {duration: 2000});
        });
    }
  }

  isBalanceExceeded( invoice): boolean {
    const net = Number(invoice?.net || 0);
    const toPayNet = Number(invoice?.contractBalance?.toPayNet || 0);
    return net === 0 ||  0 > toPayNet ;
  }

}
